<template>
    <div class="bg-white p-4">
        <button
            @click="click(0)"
            class="flex pb-2 w-full items-center hover:font-semibold"
            :class='currentYear === 0 ? "font-bold " : ""'
        >
            <font-awesome-icon v-if="currentYear === 0" class="mr-2 fa-sm" icon="chevron-right" />
            <span>Alle år</span>
        </button>
        <button
            v-for="y in allYears"
            :key="`years-${y}`"
            @click="click(y)"
            class="flex pb-2 w-full items-center hover:font-semibold"
            :class='y === currentYear ? "font-bold" : ""'
        >
            <font-awesome-icon v-if="y === currentYear" class="mr-2 fa-sm" icon="chevron-right" />
            <span>{{ y }}</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        allYears: Array,
        currentYear: Number
    },
    methods: {
        click(year) {
            this.$emit('setFilterYear', year);
        }
    }
};
</script>
